import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import React from 'react';
import DesktopDevPageSide300x250Gak from './gak/DesktopDevPageSide300x250';
import DesktopDevPageSide300x250Hashtag from './hashtag/DesktopDevPageSide300x250';
const DesktopDevPageSide300x250 = ({ safety ='off' , safetyState  })=>{
    const isHashtag = useFlag('ads_prebid');
    if (isHashtag) {
        return /*#__PURE__*/ React.createElement(DesktopDevPageSide300x250Hashtag, {
            safety: safety,
            safetyState: safetyState
        });
    }
    return /*#__PURE__*/ React.createElement(DesktopDevPageSide300x250Gak, {
        safety: safety,
        safetyState: safetyState
    });
};
DesktopDevPageSide300x250.displayName = 'DesktopDevPageSide300x250';
export default DesktopDevPageSide300x250;
